import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from "../../../@fuse/shared.module";
import { appRoutes } from "./myprofile.route";
/*Eof : Directory*/
import { MyProfileService } from "./myprofile.service";
import { ChangePasswordComponent } from "./changepassword/changepassword.component";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { CropImageComponent } from "./crop-image/crop-image.component";
import { ImageCropperModule } from "ngx-img-cropper";

import { CountryStateDropdownModule } from "../../shared/component/country-state-dropdown/country-state-dropdown.module";
//import { TextMaskModule } from 'angular2-text-mask';
import { MatFormFieldModule } from "@angular/material/form-field";
import { NgxMaskPipe, NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AuthenticationModule } from "../authentication/authentication.module";


@NgModule({
  declarations: [
    ChangePasswordComponent,
    EditProfileComponent,
    CropImageComponent
  ],
  imports: [
    RouterModule.forChild(appRoutes),
    NgxMaskDirective, 
    NgxMaskPipe,
    MatCheckboxModule,
    MatFormFieldModule,
    MatRadioModule,
    MatIconModule,
    MatInputModule,
    MatSliderModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatCardModule,
    MatSnackBarModule,
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatToolbarModule,
    MatDialogModule,
    FuseSharedModule,
    ImageCropperModule,
    CountryStateDropdownModule,
    AuthenticationModule
    //TextMaskModule
  ],
  exports: [CropImageComponent, EditProfileComponent],
  providers: [provideNgxMask()]
})

export class MyProfileModule {

}
